import { Action } from 'redux';

// State
export interface ScreensaverState {
	showScreensaver: boolean;
	showTimeoutWarning: boolean;
}

// Actions
export const SHOW_SCREENSAVER = 'SHOW_SCREENSAVER';
export const SHOW_TIMEOUT_WARNING = 'SHOW_TIMEOUT_WARNING';
export const RESET_SCREENSAVER_TIMEOUT = 'RESET_SCREENSAVER_TIMEOUT';

interface ShowScreensaver extends Action {
	type: typeof SHOW_SCREENSAVER;
	value: boolean;
}

interface ShowTimeoutWarning extends Action {
	type: typeof SHOW_TIMEOUT_WARNING;
	value: { show: boolean; sendEvent: boolean };
}

interface ResetScreensaverTimeout extends Action {
	type: typeof RESET_SCREENSAVER_TIMEOUT;
}

export type ScreensaverStateActions =
	| ShowScreensaver
	| ShowTimeoutWarning
	| ResetScreensaverTimeout;
